<div class="top-64">
  <h2 class="title">Solicite sua aposentadoria</h2>
  <p class="top-16 description">
    A previdência complementar é um investimento para o futuro. Se você sair do emprego antes de se aposentar, poderá escolher o que fazer com os recursos acumulados,
    conforme as regras do plano. São quatro opções, chamadas de institutos previdenciários: autopatrocínio e Benefício Proporcional Diferido (BPD), para manter o vínculo
    com o plano, ou portabilidade e resgate, para encerrá-lo. Essas opções valem tanto para quem pede demissão quanto para quem é demitido.
  </p>
  <h4 class="top-64 subtitle">Como funciona?</h4>
  <p class="top-32 description">
    Você consegue por esse serviço consultar o seu Extrato de Desligamento, que contém os valores e informações para cada instituto, e selecionar um
    dos institutos previdenciários. Saiba mais sobre eles abaixo:
  </p>
  <div class="steps-container">
    <div>
      1. Tenha seus documentos em mãos
      <p>
        Você mantém o vínculo com o plano e continua contribuindo, assumindo também as contribuições que eram feitas pela empresa.
      </p>
    </div>
    <div>
      2. Solicite sua aposentadoria no botão abaixo
      <p>
        Você deixa os recursos no plano, sem fazer as contribuições regulares, para receber um benefício no futuro.
      </p>
    </div>
    <div>
      3. Analisaremos sua solicitação
      <p>
        Você recebe o valor disponível para resgate e encerra o vínculo com o plano, conforme as regras do regulamento e a
        tributação aplicável.
      </p>
    </div>
    <div>
      4. Pronto!
      <p>
        Você transfere os recursos para outro plano de previdência, conforme as regras aplicáveis, e continua investindo na sua aposentadoria.
      </p>
    </div>
  </div>
  <div class="d-flex justify-content-center buttons-requerimento">
    <vivest-button variant="primary" size="md" (click)="onSubmit()">
      <vivest-icon slot="icon-right" name="arrow-right" source="feather"></vivest-icon>
      Solicitar Aposentadoria
    </vivest-button>
  </div>
</div>
